import ForecastTrendPaper from "./components/ForecastTrendPaper";
import QualifiedPipelineCoveragePaper from "./components/QualifiedPipelineCoveragePaper";
import SalesForecastCurrentQtrPaper from "./components/SalesForecastCurrentQtrPaper";
import ForecastMovedOutPaper from "./components/ForecastMovedOutPaper";
import SalesForecastNextQtrPaper from "./components/SalesForecastNextQtrPaper";
import SalesForecastNextQtrPlus1Paper from "./components/SalesForecastNextQtrPlus1Paper";
import DealProgressionPaper from "./components/DealProgressionPaper";
import DealConversionPaper from "./components/DealConversionPaper";
import WinLossAnalysisPaper from "./components/WinLossAnalysisPaper";
import MSSPFulfillmentPaper from "./components/MSSPFulfillmentPaper";
import RenewalsSummaryPaper from "./components/RenewalsSummaryPaper";
import RenewalsDetailPaper from "./components/RenewalsDetailPaper";
import UpsellCrossSellPaper from "./components/UpsellCrossSellPaper";
import UpsellCrossSellDetailPaper from "./components/UpsellCrossSellDetailPaper";
import ForecastBestCasePaper from "./components/ForecastBestCasePaper";

const regionalCardRegistry = {
  RSRP_Forecast_Trend: ForecastTrendPaper,
  RSRP_Qualified_Pipeline_Coverage: QualifiedPipelineCoveragePaper,
  RSRP_Sales_Forecast_Current_Qtr: SalesForecastCurrentQtrPaper,
  RSRP_Forecast_Moved_Out: ForecastMovedOutPaper,
  RSRP_Sales_Forecast_Next_Qtr: SalesForecastNextQtrPaper,
  RSRP_Sales_Forecast_Next_Qtr_Plus1: SalesForecastNextQtrPlus1Paper,
  RSRP_Deal_Progression: DealProgressionPaper,
  RSRP_Deal_Conversion: DealConversionPaper,
  RSRP_Win_Loss_Analysis: WinLossAnalysisPaper,
  RSRP_MSSP_Fulfillment: MSSPFulfillmentPaper,
  RSRP_Renewals_Summary: RenewalsSummaryPaper,
  RSRP_Renewals_Detail: RenewalsDetailPaper,
  RSRP_Upsell_Cross_Sell: UpsellCrossSellPaper,
  RSRP_Upsell_Cross_Sell_Detail: UpsellCrossSellDetailPaper,
  RSRP_Forecast_Best_Case: ForecastBestCasePaper,
};

/**
 * Retrieves a card component by its ID.
 * @param {string} cardId - The ID of the card to retrieve.
 * @returns {React.Component|null} The component associated with the ID, or null if not found.
 */
export function getRegionalCard(cardId) {
  return regionalCardRegistry[cardId] || null;
}
